import React, {useEffect, useState} from 'react'
import Pusher from "pusher-js"
import {Howl, Howler} from 'howler'
import {Slide} from "@material-ui/core"
import Snackbar from "@material-ui/core/Snackbar"
import {useSelector} from "react-redux"

const PusherNotifier = ({appKey, channelName, event, rest}) => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState("")
  const {user: {id}} = useSelector((state) => state.session)

  useEffect(() => {

    const sound = new Howl({
      src: '/sound/alert.mp3'
    })

    const pusher = new Pusher(appKey, {
      cluster: 'eu',
      encrypted: true
    })

    const channel = pusher.subscribe(channelName)
    channel.bind(`${event}-${id}`, function (data) {
      setMessage(data)
      setOpen(true)
      sound.play()
    })
  }, [])

  return (
    <Snackbar
      {...rest}
      anchorOrigin={{vertical: 'top', horizontal: "left"}}
      key={`loader`}
      open={open}
      autoHideDuration={4000}
      TransitionComponent={Slide}
      onClose={() => setOpen(false)}
      message={message}
    />
  )
}

export default PusherNotifier
